import {
    login,
    changePassword,
    myIdentity,
    updateProfile,
    logoutUser,
    profilePicture,
    activesemester,
    changeAccount,
    reqCurrentSemester
} from '@/store/api/AuthController'
const initialState = () => ({
    user: {},
    token: null,
    semester: null,
    currentSemester: {},
    expires_in: null,
    appkey: null,
    isLogin: false,
    response: {},
    tempName: '',
    users: [],
    scode: null,
    dcode: null,
})
const state = initialState
function makeid() {
    let result           = '';
    const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < 20; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
 
const getters = {
    getToken: state => state.token,
    getSemester: state => state.semester,
    getCurrentSemester: state => state.currentSemester,
    getAppkey: state => state.appkey,
    getUser: state => state.user,
    getRole: state => state.user.role,
    getId: state => state.user.id,
    getDetail: state => state.user.detail,
    getNotifToken: state => state.user.notifToken,
    getResponse: state => state.response,
    getTempName: state => state.tempName,
    getUsers: state => state.users,
    getUsername: state => state.user.username,
    getScode: state => state.user.scode,
    getFcode: state => state.user.faculty_code,
    getDcode: state => state.user.dcode,
    getProdi: state => state.user.study_program,
    getStatus: state => state.user.status,
    getDegree: state => state.user.degree
}

const actions = {
    async myIdentity({
        commit
    }) {
        try {
            const response = await myIdentity();
            commit('SET_USER', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async activesemester({
        commit
    }) {
        try {
            const response = await activesemester();
            commit('SET_SEMESTER', response.data)
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getCurrentSemesterData({
        commit
    }) {
        try {
            const response = await reqCurrentSemester();
            commit('SET_CURRENT_SEMESTER', response.data)
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async updateProfile({
        commit
    }, data) {
        try {
            const response = await updateProfile(data);
            commit('SET_RESPONSE', response.data)
        } catch (err) {
            console.log(err)
            commit('SET_FAILED')
        }
    },
    async profilePicture({
        commit
    }, data) {
        try {
            const response = await profilePicture(data);
            commit('SET_RESPONSE', response.data)
        } catch (err) {
            console.log(err)
            commit('SET_FAILED')
        }
    },
    async changeAccount({
        commit, rootState
    }, data) {
        try {
            const response = await changeAccount(data);
            if(response.data.status == 0){
                commit('SET_RESPONSE', response.data);
                return
            }
            commit('SET_TOKEN', response.data)
            rootState.isLoggedIn = true
            location.reload();
        } catch (err) {
            if(err.response.status == 401){
                commit('SET_RESPONSE', err.response.data);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async loginUser({
        commit, rootState
    }, data) {
        try {
            const response = await login(data);
            if(response.data.status == 0){
                commit('SET_RESPONSE', response.data);
                return
            }
            commit('SET_TOKEN', response.data)
            rootState.isLoggedIn = true
        } catch (err) {
            if(err.response?.status == 401){
                commit('SET_RESPONSE', err.response.data);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async logoutUser({
        commit
    }, data) {
        try {
            const response = await logoutUser(data);
            console.log(response)
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            commit('SET_FAILED')
        }
    },
    async changePassword({
        commit
    }, data) {
        try {
            const response = await changePassword(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    }
}

const mutations = {
    SET_FAILED(state) {
        state.response = {
            msg: 'Jaringan Bermasalah',
            status: '0'
        }
    },

    SET_TEMPNAME(state, value) {
        state.tempName = value
    },

    SET_RESPONSE(state, response) {
        state.response = response
    },

    SET_USER(state, source) {
        state.response = source
        state.user = source.data
        localStorage.setItem('BimbinganUAJY-role',source.data.role)
    },
    
    SET_TOKEN(state, data) {
        state.response = data
        state.user = data.user;
        state.token = data.access_token
        state.semester = data.activeSemester
        state.users = data.user.users
        const key = makeid()
        state.appkey = key
        localStorage.setItem('appkey',key)
        localStorage.setItem('BimbinganUAJY-role',data.user.role)
    },

    SET_SEMESTER(state, value){
        state.semester = value
    },
    SET_CURRENT_SEMESTER(state, value){
        state.currentSemester = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}